import { render, staticRenderFns } from "./patientDetail.vue?vue&type=template&id=22b522b1&scoped=true"
import script from "./patientDetail.vue?vue&type=script&lang=js"
export * from "./patientDetail.vue?vue&type=script&lang=js"
import style0 from "./patientDetail.vue?vue&type=style&index=0&id=22b522b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b522b1",
  null
  
)

export default component.exports